import React from 'react';
import { Collapse, MenuItem } from '@mui/material';
import MainMenuItemContent from './MainMenuItemContent';
import AccurityIcon from '../../icon/components/AccurityIcon';
var MainMenuGroup = function (_a) {
    var name = _a.name, label = _a.label, icon = _a.icon, isGroupExpanded = _a.isGroupExpanded, onGroupClick = _a.onGroupClick, children = _a.children;
    var toggleExpandGroup = function () { return onGroupClick === null || onGroupClick === void 0 ? void 0 : onGroupClick(name); };
    var expanded = isGroupExpanded === null || isGroupExpanded === void 0 ? void 0 : isGroupExpanded(name);
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { disableRipple: true, onClick: toggleExpandGroup, classes: { root: "mainMenu__menuGroup" } },
            React.createElement(MainMenuItemContent, { icon: icon, label: label }),
            React.createElement(AccurityIcon, { iconName: expanded ? 'mui:ExpandLess' : 'mui:ExpandMore' })),
        React.createElement(Collapse, { in: expanded }, children)));
};
export default MainMenuGroup;
//# sourceMappingURL=MainMenuGroup.js.map